import { get } from 'lodash/fp';

export const isTwoFactorEnabledSelector = (data) => get('IsTwoFactorEnabled', data);
export const enrollQRCodeSelector = (data) =>
    get('AsynchronousParameters.ActivationQrCodeUrl', data);
export const enrollmentSessionIdSelector = (data) => get('EnrollmentSessionId', data);
export const enrollStatusSelector = (data) => get('Status', data);
